var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1351 0.55249C7.90577 0.55249 9.52976 1.4123 10.5775 2.82718C11.6252 1.4123 13.2492 0.55249 15.0199 0.55249C18.1159 0.55249 20.6357 3.18089 20.6357 6.41334C20.6357 7.93161 20.0804 9.37369 19.0694 10.4729L11.1485 18.7826L10.5775 19.3812L10.0065 18.7826L2.23752 10.6308C1.1374 9.52607 0.519238 8.02412 0.519238 6.41334C0.519238 3.18089 3.03904 0.55249 6.1351 0.55249Z",
    fill: "#22D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHeart);
export default __webpack_public_path__ + "static/media/emptyHeart.742e71fe6623f332a1fa2cdad9a799c9.svg";
export { ForwardRef as ReactComponent };